import { useQuery } from '@tanstack/react-query';
import { getMapPeopleIcons, MapPeopleIconsFilters } from '../../services/mapPeopleIcons.service';

export const mapPeopleIconsKeys = {
  all: ['map-people-icons'] as const,
  lists: () => [...mapPeopleIconsKeys.all, 'list'] as const,
  list: (filters: MapPeopleIconsFilters) => [...mapPeopleIconsKeys.lists(), filters] as const,
};

export function useMapPeopleIcon(filters: MapPeopleIconsFilters = {}) {
  return useQuery({
    queryKey: mapPeopleIconsKeys.list(filters),
    queryFn: () => getMapPeopleIcons(),
    placeholderData: (previousData) => previousData,
  });
}
